import React from 'react';

const GameHeader = ({ tapCount, speed, deviceInfo, onSignOut }) => {
  return (
    <div className="game-header">
      <div className="header-top">
        <h1>🚗 RACE TO THE CLIENT! 🏁</h1>
        {deviceInfo && (
          <div className="device-info">
            <span>👤 {deviceInfo.firstName} {deviceInfo.lastName}</span>
            <button className="sign-out-btn" onClick={onSignOut}>
              Sign Out
            </button>
          </div>
        )}
      </div>
      <div className="stats">
        <div className="stat-item">
          <span className="stat-label">Taps:</span>
          <span className="stat-value">{tapCount}</span>
        </div>
        <div className="stat-item">
          <span className="stat-label">Speed:</span>
          <span className="stat-value">{speed.toFixed(2)}</span>
          <span className="unit">TPS</span>
        </div>
      </div>
    </div>
  );
};

export default GameHeader;
